import { AlertTriangle } from 'lucide-react';
import {
  VERIFICATION_UNAVAILABLE_BODY,
  VERIFICATION_UNAVAILABLE_BODY_SHORT,
  VERIFICATION_UNAVAILABLE_TITLE,
} from '@/lib/verificationStatus';

interface Props {
  /** Compact single-line variant for inline placement inside a row or drawer. */
  compact?: boolean;
  className?: string;
}

/**
 * Shown on every verification surface while verification is non-functional.
 * See src/lib/verificationStatus.ts for why.
 */
export default function VerificationUnavailableNotice({ compact, className }: Props) {
  return (
    <div
      role="status"
      className={`rounded-lg border border-amber-300 bg-amber-50 p-4 text-amber-900 ${className ?? ''}`}
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
        <div className="space-y-1">
          <p className="font-semibold">{VERIFICATION_UNAVAILABLE_TITLE}</p>
          <p className="text-sm leading-relaxed">
            {compact ? VERIFICATION_UNAVAILABLE_BODY_SHORT : VERIFICATION_UNAVAILABLE_BODY}
          </p>
        </div>
      </div>
    </div>
  );
}
